import { GraphicObjectCreator } from "./graphic-object-creator";
import { SingleNamedObject } from "../../../../../web-graphics";

export class ItemContainerCreator extends GraphicObjectCreator {
  constructor(commonSettings) {
    super();
    this.callbackPlaces.push("beforeAddItems");
    this.callbacks.set("beforeAddItems", []);
    this.commonSettings = commonSettings;
  }

  static createItem(itemSettings, viewObjectCreators, parentObject, canvasObject, idGenerator, addItemToContainerFunc) {
    let itemCreator = viewObjectCreators.get(itemSettings.type);
    itemSettings._idGenerator = idGenerator;
    itemSettings._viewObjectCreators = viewObjectCreators;
    itemSettings._parentObject = parentObject;
    itemSettings._canvasObject = canvasObject;
    itemSettings._id = idGenerator.generateNextId();
    let itemObject = itemCreator.create(itemSettings);

    if (itemObject !== undefined) {
      itemObject._id = itemSettings._id;
      addItemToContainerFunc(new SingleNamedObject(`${itemSettings._id}`, itemObject));
    }
  }
}
